import { useCssVars as _useCssVars, unref as _unref } from 'vue'
import ProgressBar from 'primevue/progressbar'
import {computed} from 'vue'


export default {
  __name: 'progressbar',
  props: {
  value: {
    type: Number,
    default: 0
  },
  valueTitle: {
    type: Number,
    default: undefined
  },
  success: {
    type: Boolean,
    default: false
  },
  error: {
    type: Boolean,
    default: false
  },
  symb: {
    type: String,
    default: '%'
  },
  label: {
    type: Boolean,
    default: true
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

_useCssVars(_ctx => ({
  "7ba351c6-c_bg": (c_bg.value),
  "7ba351c6-c_color": (c_color.value)
}))

const props = __props

const pt = {
  root: 'root',
  value: 'value',
  label: 'label'
}

const c_bg = computed(() => props.error ? 'var(--error-600)' : 'var(--gray-200)')
const c_val = computed(() =>  props.valueTitle === undefined ? props.value : props.valueTitle)
const c_color = computed(() => {
  if (props.success) return 'var(--success-500)'
  if (props.error) return'var(--error-600)'
  return 'var(--primary-600)'
})

const __returned__ = { props, pt, c_bg, c_val, c_color, get ProgressBar() { return ProgressBar }, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}